import { KeyValue } from "@/main/models/common";
import { SupplierFilterRequest } from "@/main/models/request";

export enum SupplierTypes {
	GET_SUPPLIERS = "@supplier/GET_SUPPLIERS",
	SAVE_SUPPLIERS = "@supplier/SAVE_SUPPLIERS",
	RESET_REDUCER_SUPPLIERS = "@supplier/RESET_REDUCER_SUPPLIERS",
}

export interface SupplierState {
	readonly suppliers: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetSuppliers {
	type: typeof SupplierTypes.GET_SUPPLIERS;
	payload: {
		request: SupplierFilterRequest;
	};
}

export interface SaveSuppliers {
	type: typeof SupplierTypes.SAVE_SUPPLIERS;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerSuppliers {
	type: typeof SupplierTypes.RESET_REDUCER_SUPPLIERS;
}

export type SupplierActionTypes = GetSuppliers | SaveSuppliers | ResetReducerSuppliers;
